import { useQuery } from '@tanstack/react-query';
import { planetsQueryOptions, planetQueryOptions } from '../server/queries/planets';

/**
 * Fetches the full list of planets.
 */
export function usePlanets() {
  return useQuery(planetsQueryOptions());
}

/**
 * Fetches a single planet by ID.
 */
export function usePlanet(id: string) {
  return useQuery(planetQueryOptions(id));
}
